export const RESET_APPOINTMENT_DETAILS = "RESET_APPOINTMENT_DETAILS";
export const CONTACT_ADDRESS_RADIO_BUTTON_VALUE = " CONTACT_ADDRESS_RADIO_BUTTON_VALUE";
export const ADDRESS_RADIO_BUTTON_VALUE = "ADDRESS_RADIO_BUTTON_VALUE";
export const SET_CONTACT_DETAILS_FIELDS = "SET_CONTACT_DETAILS_FIELDS";
export const SET_LOADER = "SET_LOADER";
export const FETCH_FEE = "FETCH_FEE";
export const SET_FEE = "SET_FEE";
export const FETCH_STATES = "FETCH_STATES";
export const SET_STATES = "SET_STATES";
export const GET_CONTACT_VALUES = "GET_CONTACT_VALUES";
export const SET_CONTACT_FORM_VALUES = "SET_CONTACT_FORM_VALUES";
export const SET_SERVICE_DETAILS = "SET_SERVICE_DETAILS";
export const VALIDATE_NEW_VIN = "VALIDATE_NEW_VIN";
export const CHECK_VIN_COMPATIBILITY = "CHECK_VIN_COMPATIBILITY";
export const FETCH_ACCOUNT_DETAILS = "FETCH_ACCOUNT_DETAILS";
export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const FETCH_MATERIAL_LIST = "FETCH_MATERIAL_LIST";
export const SET_MATERIAL_LIST = "SET_MATERIAL_LIST";
export const SET_APPOINTMENT_TOTAL_NUMBER_OF_RECORDS = "SET_APPOINTMENT_TOTAL_NUMBER_OF_RECORDS";
export const SET_APPOINTMENT_PER_PAGE = "SET_APPOINTMENT_PER_PAGE";
export const SET_APPOINTMENT_ACTIVE_PAGE = "SET_APPOINTMENT_ACTIVE_PAGE";
export const SET_ALL_APPOINTMENTS = "SET_ALL_APPOINTMENTS";
export const GET_ALL_APPOINTMENT = "GET_ALL_APPOINTMENT";
export const FILTER_APPOINTMENT_LIST = "FILTER_APPOINTMENT_LIST";
export const SET_RESCHEDULE = "SET_RESCHEDULE";
export const SET_RESCHEDULE_APPOINTMENT_DETAILS = "SET_RESCHEDULE_APPOINTMENT_DETAILS";
export const SET_SERVICE_TOTAL_FEES = "SET_SERVICE_TOTAL_FEES";
export const SET_JOB_DURATION_DETAILS = "SET_JOB_DURATION_DETAILS";
export const SET_EST_APPOINTMENT_LENGTH = "SET_EST_APPOINTMENT_LENGTH";
export const TECHNICIAN_APPOINTMENT_VALIDATE_ADDRESS = "TECHNICIAN_APPOINTMENT_VALIDATE_ADDRESS";
export const SET_ADDRESS_VALIDATION_RESPONSE = "SET_ADDRESS_VALIDATION_RESPONSE";
export const IS_VALIDATE_ADDRESS = "IS_VALIDATE_ADDRESS";
export const SET_NEW_CASE_DETAILS = "SET_NEW_CASE_DETAILS";
export const SET_CASENUMBER = "SET_CASENUMBER";
export const SET_CASE_SFDC_ID = "SET_CASE_SFDC_ID";
export const SET_CASE_SUBJECT = "SET_CASE_SUBJECT";
export const SET_SLOT_DETAILS = "SET_SLOT_DETAILS";
export const GET_ADDRESS_VALUE = "GET_ADDRESS_VALUE";
export const GET_EXISTING_ADDRESS_VALUE = "GET_EXISTING_ADDRESS_VALUE";
export const SET_NOTES_TO_TECHNICIAN = "SET_NOTES_TO_TECHNICIAN";
export const UPDATE_CASE_DETAILS = "UPDATE_CASE_DETAILS";
export const SET_UPDATE_CASE_PAYLOAD = "SET_UPDATE_CASE_PAYLOAD";
export const FETCH_RESCHEDULE_REASON_LIST = "FETCH_RESCHEDULE_REASON_LIST";
export const SET_RESCHEDULE_REASON_LIST = "SET_RESCHEDULE_REASON_LIST";
export const CREATE_RESCHEDULE = "CREATE_RESCHEDULE";
export const SET_JOB_RESP = "SET_JOB_RESP";
export const GET_JOB_DETAILS = "GET_JOB_DETAILS";
export const SET_JOB_DETAILS = "SET_JOB_DETAILS";
export const SET_JOB_DETAILS_API_FAILED = "SET_JOB_DETAILS_API_FAILED";
export const SET_UPDATE_JOB_PAYLOAD = "SET_UPDATE_JOB_PAYLOAD";
export const UPDATE_JOB = "UPDATE_JOB";
export const CREATE_SCHEDULE = "CREATE_SCHEDULE";
export const SET_PREFERRED_DATE = "SET_PREFERRED_DATE";
export const SET_CONTACT_FORM_ERROR = "SET_CONTACT_FORM_ERROR";
export const SET_EDITED_CONTACT_FORM_VALUES = "SET_EDITED_CONTACT_FORM_VALUES";
export const FETCH_REVEAL_VEHICLES = "FETCH_REVEAL_VEHICLES";
export const SET_REVEAL_VEHICLES = "SET_REVEAL_VEHICLES";
export const SET_MATERIAL_LIST_SKELTON_LOADER = "SET_MATERIAL_LIST_SKELTON_LOADER";
export const SET_VEHICLE_AND_ASSET_LIST = "SET_VEHICLE_AND_ASSET_LIST";
export const ADDRESS_VALIDATION_API_CHECK = "ADDRESS_VALIDATION_API_CHECK";
export const SCHEDULE_CREATE_NEW_CASE = "SCHEDULE_CREATE_NEW_CASE";
export const CLOSE_CASE_AND_JOB = "CLOSE_CASE_AND_JOB";
export const GET_VIN_FEATURES = "GET_VIN_FEATURES";
export const SET_CREATE_CASE_API_FAILURE = "SET_CREATE_CASE_API_FAILURE";
export const GET_VIN_CONTROL_UNITS = "GET_VIN_CONTROL_UNITS";
export const IS_ASSISTANCE_REQUIRED = "IS_ASSISTANCE_REQUIRED";
export const SET_ASSISTANCE_CASE_DETAILS = "SET_ASSISTANCE_CASE_DETAILS";
export const SET_IS_UPDATE_CASE_API_FAILED = "SET_IS_UPDATE_CASE_API_FAILED";
export const JOB_FAILURE = "JOB_FAILURE";
export const SET_IS_SCHEDULE_API_FAILED = "SET_IS_SCHEDULE_API_FAILED";
export const UPDATE_CASE_ON_API_FAILURE_RESCHEDULE = "UPDATE_CASE_ON_API_FAILURE_RESCHEDULE";
export const IS_WITHIN_THREE_BUSINESS_DAYS = "IS_WITHIN_THREE_BUSINESS_DAYS";
export const SET_JOB_DURATION_EXCEEDS_10_HRS = "SET_JOB_DURATION_EXCEEDS_10_HRS";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const UPDATE_CASE_ON_RESCHEDULE = "UPDATE_CASE_ON_RESCHEDULE";
export const RESCHEDULE_SCHEDULING_NOTES = "RESCHEDULE_SCHEDULING_NOTES";
export const SET_RESCHEDULE_SCHEDULING_EMAIL = "SET_RESCHEDULE_SCHEDULING_EMAIL";
export const ACCESSORIES_LOADER = "ACCESSORIES_LOADER";
export const RESET_CONTACT_DETAILS_PAGE_DATA = "RESET_CONTACT_DETAILS_PAGE_DATA";
export const IS_EXISTING_CONTACT_NAME_EDITED = "IS_EXISTING_CONTACT_NAME_EDITED";
export const IS_STATUS = "IS_STATUS";

export function getContactValues(value) {
  return {
    type: GET_CONTACT_VALUES,
    value,
  };
}

export function setContactFormValues(value) {
  // actual store and api
  return {
    type: SET_CONTACT_FORM_VALUES,
    value,
  };
}

export function resetAppointmentDetails() {
  return {
    type: RESET_APPOINTMENT_DETAILS,
  };
}

export function userSelectedContactOption(value) {
  return {
    type: CONTACT_ADDRESS_RADIO_BUTTON_VALUE,
    value,
  };
}

export function userSelectedAddressOption(value) {
  return {
    type: ADDRESS_RADIO_BUTTON_VALUE,
    value,
  };
}

export function setContactDetailsFields(value) {
  return {
    type: SET_CONTACT_DETAILS_FIELDS,
    value,
  };
}

export function setLoader(value) {
  return {
    type: SET_LOADER,
    value,
  };
}

export function fetchFee() {
  return {
    type: FETCH_FEE,
  };
}

export function setJobDurationDetails(value) {
  return {
    type: SET_JOB_DURATION_DETAILS,
    value,
  };
}

export function setEstAppointmentLength(value) {
  return {
    type: SET_EST_APPOINTMENT_LENGTH,
    value,
  };
}

export function setFeeDetails(value) {
  return {
    type: SET_FEE,
    value,
  };
}

export function setServiceTotalFee(value) {
  return {
    type: SET_SERVICE_TOTAL_FEES,
    value,
  };
}

export function fetchStates() {
  return {
    type: FETCH_STATES,
  };
}

export function setStates(value) {
  return {
    type: SET_STATES,
    value,
  };
}

export function setServiceDetails(serviceDetailsList) {
  return {
    type: SET_SERVICE_DETAILS,
    serviceDetailsList,
  };
}

export function validateVin(vin, callBack) {
  return {
    type: VALIDATE_NEW_VIN,
    vin,
    callBack,
  };
}
export function checkVinCompatibility(oldVin, newVin, accessories, boxName, callBack, toLoad = false) {
  return {
    type: CHECK_VIN_COMPATIBILITY,
    oldVin,
    newVin,
    accessories,
    boxName,
    callBack,
    toLoad,
  };
}
export function fetchAccountDetails(accountId) {
  return {
    type: FETCH_ACCOUNT_DETAILS,
    accountId,
  };
}

export function setAccountDetails(value) {
  return {
    type: SET_ACCOUNT_DETAILS,
    value,
  };
}

export function setTotalNumberOfRecords(value) {
  return {
    type: SET_APPOINTMENT_TOTAL_NUMBER_OF_RECORDS,
    value,
  };
}

export function fetchMaterialList(payload, toLoad = true) {
  return {
    type: FETCH_MATERIAL_LIST,
    payload,
    toLoad,
  };
}

export function setMaterialList(value) {
  return {
    type: SET_MATERIAL_LIST,
    value,
  };
}
export function setAppointmentPerPage(value) {
  return {
    type: SET_APPOINTMENT_PER_PAGE,
    value,
  };
}

export function setActivePage(value) {
  return {
    type: SET_APPOINTMENT_ACTIVE_PAGE,
    value,
  };
}

export function setAllAppointments(response) {
  return {
    type: SET_ALL_APPOINTMENTS,
    response,
  };
}

export function getAllAppointment(callBack) {
  return {
    type: GET_ALL_APPOINTMENT,
    callBack,
  };
}

export function filteredAppointmentList(response) {
  return {
    type: FILTER_APPOINTMENT_LIST,
    response,
  };
}

export function setReschedule(value) {
  return {
    type: SET_RESCHEDULE,
    value,
  };
}
export function technicianAppointmentValidateAddress(response) {
  return {
    type: TECHNICIAN_APPOINTMENT_VALIDATE_ADDRESS,
    response,
  };
}

export function setAddressValidationResponse(response) {
  return {
    type: SET_ADDRESS_VALIDATION_RESPONSE,
    response,
  };
}

export function setIsValidateAddress(response) {
  return {
    type: IS_VALIDATE_ADDRESS,
    response,
  };
}

export function setNewCaseDetails() {
  return {
    type: SET_NEW_CASE_DETAILS,
  };
}

export function setCaseNumber(value) {
  return {
    type: SET_CASENUMBER,
    value,
  };
}

export function setRescheduleAppointmentDetails(value) {
  return {
    type: SET_RESCHEDULE_APPOINTMENT_DETAILS,
    value,
  };
}

export function setCaseSfdcId(value) {
  return {
    type: SET_CASE_SFDC_ID,
    value,
  };
}

export function setCaseSubject(value) {
  return {
    type: SET_CASE_SUBJECT,
    value,
  };
}

export function setSelectedSlotDetails(value) {
  return {
    type: SET_SLOT_DETAILS,
    value,
  };
}

export function getAddressValue(value) {
  return {
    type: GET_ADDRESS_VALUE,
    value,
  };
}

export function getExistingAddressValue(value) {
  return {
    type: GET_EXISTING_ADDRESS_VALUE,
    value,
  };
}

export function setNotesToTechnician(value) {
  return {
    type: SET_NOTES_TO_TECHNICIAN,
    value,
  };
}

export function updateCaseOnSchedule(value = {}) {
  return {
    type: UPDATE_CASE_DETAILS,
    value,
  };
}

export function setUpdateCasePayload(value) {
  return {
    type: SET_UPDATE_CASE_PAYLOAD,
    value,
  };
}

export function fetchRescheduleReasonList(callback) {
  return {
    type: FETCH_RESCHEDULE_REASON_LIST,
    callback,
  };
}

export function setRescheduleReasonList(value) {
  return {
    type: SET_RESCHEDULE_REASON_LIST,
    value,
  };
}

export function createReschedule(callBack) {
  return {
    type: CREATE_RESCHEDULE,
    callBack,
  };
}
export function setAddJobResp(value) {
  return {
    type: SET_JOB_RESP,
    value,
  };
}

export function getJobDetails(appointmentId, setLoader) {
  return {
    type: GET_JOB_DETAILS,
    appointmentId,
    setLoader,
  };
}

export function setJobDetails(value) {
  return {
    type: SET_JOB_DETAILS,
    value,
  };
}

export function setJobDetailsApiFailed(value) {
  return {
    type: SET_JOB_DETAILS_API_FAILED,
    value,
  };
}
export function setUpdateJob(value) {
  return {
    type: SET_UPDATE_JOB_PAYLOAD,
    value,
  };
}

export function updateJobCall(incrementStep) {
  return {
    type: UPDATE_JOB,
    incrementStep,
  };
}

export function createScheduleCall(callBack) {
  return {
    type: CREATE_SCHEDULE,
    callBack,
  };
}

export function setPreferredDate(value) {
  return {
    type: SET_PREFERRED_DATE,
    value,
  };
}

export function setIsContactFormError(value) {
  return {
    type: SET_CONTACT_FORM_ERROR,
    value,
  };
}

export function setEditedContactFormValues(value) {
  return {
    type: SET_EDITED_CONTACT_FORM_VALUES,
    value,
  };
}

export function fetchRevealVehicles(toLoad = true) {
  return {
    type: FETCH_REVEAL_VEHICLES,
    toLoad,
  };
}

export function setRevealVehicles(value) {
  return {
    type: SET_REVEAL_VEHICLES,
    value,
  };
}
export function setMaterialListSkeltonLoader(value) {
  return {
    type: SET_MATERIAL_LIST_SKELTON_LOADER,
    value,
  };
}

export function setVehicleAndAssetList(value) {
  return {
    type: SET_VEHICLE_AND_ASSET_LIST,
    value,
  };
}

export function addressValidationApiCheck(value) {
  return {
    type: ADDRESS_VALIDATION_API_CHECK,
    value,
  };
}

export function createNewCaseCall(incrementStep) {
  return {
    type: SCHEDULE_CREATE_NEW_CASE,
    incrementStep,
  };
}

export function closeCaseAndJobCall(callBack) {
  return {
    type: CLOSE_CASE_AND_JOB,
    callBack,
  };
}
export function getVinFeatures(vin, boxName, callBack) {
  return {
    type: GET_VIN_FEATURES,
    vin,
    boxName,
    callBack,
  };
}

export function getVinControlUnits(esn, callBack, toLoad) {
  return {
    type: GET_VIN_CONTROL_UNITS,
    esn,
    callBack,
    toLoad,
  };
}

export function setCreateCaseAPIFailure(value) {
  return {
    type: SET_CREATE_CASE_API_FAILURE,
    value,
  };
}

export function setIsAssistanceRequired(value) {
  return {
    type: IS_ASSISTANCE_REQUIRED,
    value,
  };
}

export function setAssistanceCaseDetails(value) {
  return {
    type: SET_ASSISTANCE_CASE_DETAILS,
    value,
  };
}

export function setIsUpdateCaseApiFailed(value) {
  return {
    type: SET_IS_UPDATE_CASE_API_FAILED,
    value,
  };
}

export function setAPIFailure(value) {
  return {
    type: JOB_FAILURE,
    value,
  };
}

export function setIsScheduleAPIFailed(value) {
  return {
    type: SET_IS_SCHEDULE_API_FAILED,
    value,
  };
}

export function updateCaseOnAPIFailureRescheduleCall(callback) {
  return {
    type: UPDATE_CASE_ON_API_FAILURE_RESCHEDULE,
    callback,
  };
}

export function setIsWithinThreeBusinessDays(value) {
  return {
    type: IS_WITHIN_THREE_BUSINESS_DAYS,
    value,
  };
}

export function setJobDurationExceeds10Hrs(value) {
  return {
    type: SET_JOB_DURATION_EXCEEDS_10_HRS,
    value,
  };
}

export function setCurrentPage(value) {
  return {
    type: SET_CURRENT_PAGE,
    value,
  };
}

export function setRescheduleSchedulingNotes(value) {
  return {
    type: RESCHEDULE_SCHEDULING_NOTES,
    value,
  };
}
export function setRescheduleSchedulingEmail(value) {
  return {
    type: SET_RESCHEDULE_SCHEDULING_EMAIL,
    value,
  };
}

export function resetContactDetailsPageData() {
  return {
    type: RESET_CONTACT_DETAILS_PAGE_DATA,
  };
}

export function setAccessoriesLoader(value) {
  return {
    type: ACCESSORIES_LOADER,
    value,
  };
}

export function setIsExistingContactNameEdited(value) {
  return {
    type: IS_EXISTING_CONTACT_NAME_EDITED,
    value,
  };
}

export function setIsStatus(value) {
  return {
    type: IS_STATUS,
    value,
  };
}
